"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserRoleSortRankFrench = exports.UserRoleSortRankEnglish = exports.UserRole = void 0;
// All these role values must be unique
var UserRole;
(function (UserRole) {
    // Internal
    UserRole[UserRole["CmhcAdministrator"] = 1] = "CmhcAdministrator";
    UserRole[UserRole["BusinessUser"] = 2] = "BusinessUser";
    UserRole[UserRole["Clerk"] = 3] = "Clerk";
    UserRole[UserRole["MasterUser"] = 4] = "MasterUser";
    UserRole[UserRole["ReadOnly"] = 5] = "ReadOnly";
    UserRole[UserRole["PortfolioAnalyst"] = 6] = "PortfolioAnalyst";
    // External
    UserRole[UserRole["ApprovedLender"] = 100] = "ApprovedLender";
    UserRole[UserRole["LenderAdministrator"] = 101] = "LenderAdministrator";
    UserRole[UserRole["ServiceProvider"] = 102] = "ServiceProvider";
})(UserRole = exports.UserRole || (exports.UserRole = {}));
var UserRoleSortRankEnglish;
(function (UserRoleSortRankEnglish) {
    UserRoleSortRankEnglish[UserRoleSortRankEnglish["ApprovedLender"] = 1] = "ApprovedLender";
    UserRoleSortRankEnglish[UserRoleSortRankEnglish["BusinessUser"] = 2] = "BusinessUser";
    UserRoleSortRankEnglish[UserRoleSortRankEnglish["Clerk"] = 3] = "Clerk";
    UserRoleSortRankEnglish[UserRoleSortRankEnglish["CmhcAdministrator"] = 4] = "CmhcAdministrator";
    UserRoleSortRankEnglish[UserRoleSortRankEnglish["LenderAdministrator"] = 5] = "LenderAdministrator";
    UserRoleSortRankEnglish[UserRoleSortRankEnglish["MasterUser"] = 6] = "MasterUser";
    UserRoleSortRankEnglish[UserRoleSortRankEnglish["None"] = 7] = "None";
    UserRoleSortRankEnglish[UserRoleSortRankEnglish["PortfolioAnalyst"] = 8] = "PortfolioAnalyst";
    UserRoleSortRankEnglish[UserRoleSortRankEnglish["ReadOnly"] = 9] = "ReadOnly";
    UserRoleSortRankEnglish[UserRoleSortRankEnglish["ServiceProvider"] = 10] = "ServiceProvider";
})(UserRoleSortRankEnglish = exports.UserRoleSortRankEnglish || (exports.UserRoleSortRankEnglish = {}));
var UserRoleSortRankFrench;
(function (UserRoleSortRankFrench) {
    UserRoleSortRankFrench[UserRoleSortRankFrench["ApprovedLender"] = 8] = "ApprovedLender";
    UserRoleSortRankFrench[UserRoleSortRankFrench["BusinessUser"] = 10] = "BusinessUser";
    UserRoleSortRankFrench[UserRoleSortRankFrench["Clerk"] = 6] = "Clerk";
    UserRoleSortRankFrench[UserRoleSortRankFrench["CmhcAdministrator"] = 1] = "CmhcAdministrator";
    UserRoleSortRankFrench[UserRoleSortRankFrench["LenderAdministrator"] = 2] = "LenderAdministrator";
    UserRoleSortRankFrench[UserRoleSortRankFrench["MasterUser"] = 9] = "MasterUser";
    UserRoleSortRankFrench[UserRoleSortRankFrench["None"] = 4] = "None";
    UserRoleSortRankFrench[UserRoleSortRankFrench["PortfolioAnalyst"] = 3] = "PortfolioAnalyst";
    UserRoleSortRankFrench[UserRoleSortRankFrench["ReadOnly"] = 7] = "ReadOnly";
    UserRoleSortRankFrench[UserRoleSortRankFrench["ServiceProvider"] = 5] = "ServiceProvider";
})(UserRoleSortRankFrench = exports.UserRoleSortRankFrench || (exports.UserRoleSortRankFrench = {}));
